import MobilePage from "../../UiComponents/MobilePage";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import HeroSetting from "./HeroSetting";
import FamilySetting from "./FamilySetting";
import FriendSetting from "./FriendSetting";
import PetSetting from "./PetSetting";
import "./Settings.css";
import butterflyApi from "../../ButterflyApi";

const SettingV2 = ({ }) => {

  const navigate = useNavigate();
  const heroNo = useParams().heroNo
  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState('')
  const [editingCards, setEditingCards] = useState(() => new Set())
  const editing = editingCards.size > 0
  const setEditing = useCallback((id, updated) => {
    setEditingCards(current => {
      const next = new Set(current)
      if (updated) next.add(id)
      else next.delete(id)
      return next
    })
  }, [])
  const [writingReadyChecked, setWritingReadyChecked] = useState(false)

  const onWritingReady = async (e) => {
    const checked = e.target.checked
    setWritingReadyChecked(checked)

    // 주인공 사진이 등록되어 있지 않으면, 주인공 사진이 필수라는 알럿 노출 후 그냥 리턴
    const data = await butterflyApi.getHeroes();
    const hero = data?.items?.find(_hero => _hero.heroNo == heroNo);
    if (!hero?.imageUrl) {
      alert("주인공 사진 등록이 필요합니다.");
      setWritingReadyChecked(false);
      return;
    }

    const result = await butterflyApi.updateWritingReady(heroNo, checked)
    if (result === undefined) {
      setWritingReadyChecked(!checked)
    }
  }

  const load = async () => {
    const data = await butterflyApi.getHeroes()
    const hero = data?.items?.filter(_hero => _hero.heroNo == heroNo)?.[0]
    setWritingReadyChecked(Boolean(hero?.writingReady))
  }

  const onDeleteHero = async () => {
    if (!window.confirm('정말 삭제하시겠습니까?\n삭제된 주인공 정보는 복구할 수 없습니다.')) return
    const result = await butterflyApi.deleteHero(heroNo)
    if (result !== undefined) {
      const heroesResponse = await butterflyApi.getHeroes()
      const heroes = heroesResponse?.items || []
      localStorage.setItem("heroes", JSON.stringify(heroes))
      if (heroes.length > 0) {
        localStorage.setItem("heroNo", heroes[0].heroNo)
      } else {
        localStorage.removeItem("heroNo")
      }
      navigate('/heroes')
    } else {
      alert('삭제 중 오류가 발생했습니다.')
    }
  }

  useEffect(() => {
    load()
  }, [heroNo])

  return <MobilePage className="storybook-page settings-page" loading={loading} loadingMessage={loadingMessage}>
    <main className="settings-content">
      <Link className="book-text-link settings-back" to="/heroes"><span aria-hidden="true">←</span> 나의 주인공</Link>
      <header className="settings-intro">
        <p className="book-eyebrow"><span aria-hidden="true">✦</span> 이야기의 시작</p>
        <h1 className="book-title">우리 아이의 세상을<br />동화에 담아주세요</h1>
        <p className="book-description">익숙한 얼굴, 다정한 이름들.<br />아이가 사랑하는 모두가 이야기의 주인공이 돼요.</p>
      </header>

      <label className="settings-ready">
        <span><strong>이야기 생성하기</strong><small>{writingReadyChecked ? '우리 아이의 이야기를 만들 준비가 됐어요.' : '주인공 사진을 등록한 뒤 켜주세요.'}</small></span>
        <span className="settings-switch">
          <input type="checkbox" role="switch" aria-label="이야기 생성하기" checked={writingReadyChecked} onChange={onWritingReady} disabled={loading || editing} />
          <span className="settings-switch-track" aria-hidden="true" />
        </span>
      </label>
      <p className="settings-privacy"><span aria-hidden="true">i</span>업로드한 사진 파일은 동화 이미지로 변환한 후 자동으로 삭제됩니다.</p>

      <nav className="settings-jump" aria-label="설정 항목 바로가기">
        <a href="#hero-profile">주인공</a>
        <a href="#hero-family">가족</a>
        <a href="#hero-friends">친구</a>
        <a href="#hero-pets">반려동물</a>
      </nav>
      {editing && <p className="settings-edit-notice" role="status">수정 중인 카드에서 저장하거나 취소한 뒤, 다른 정보를 편집할 수 있어요.</p>}

      <section className="settings-section" id="hero-profile" aria-labelledby="hero-profile-heading">
        <SettingSectionTitle id="hero-profile-heading" number="01" title="이야기의 주인공" description="아이의 이름과 사진을 알려주세요." />
        <HeroSetting heroNo={heroNo} setLoading={setLoading} setLoadingMessage={setLoadingMessage} editing={editing} setEditing={setEditing} />
      </section>
      <section className="settings-section" id="hero-family" aria-labelledby="hero-family-heading">
        <SettingSectionTitle id="hero-family-heading" number="02" title="사랑하는 가족" description="늘 곁에 있는 가족도 동화 속으로 초대해요." />
        <FamilySetting heroNo={heroNo} setLoading={setLoading} setLoadingMessage={setLoadingMessage} editing={editing} setEditing={setEditing} />
      </section>
      <section className="settings-section" id="hero-friends" aria-labelledby="hero-friends-heading">
        <SettingSectionTitle id="hero-friends-heading" number="03" title="함께하는 친구" description="단짝 친구와 함께라면 모험은 더 즐거워요." />
        <FriendSetting heroNo={heroNo} setLoading={setLoading} editing={editing} setEditing={setEditing} />
      </section>
      <section className="settings-section" id="hero-pets" aria-labelledby="hero-pets-heading">
        <SettingSectionTitle id="hero-pets-heading" number="04" title="소중한 반려동물" description="작은 발걸음으로 함께할 친구를 소개해요." />
        <div className="setting-stack">
          <PetSetting heroNo={heroNo} petKindName="강아지" setLoading={setLoading} editing={editing} setEditing={setEditing} />
          <PetSetting heroNo={heroNo} petKindName="고양이" setLoading={setLoading} editing={editing} setEditing={setEditing} />
        </div>
      </section>

      <footer>
        <div className="settings-danger">
          <p>주인공을 삭제하면<br />등록한 정보를 복구할 수 없어요.</p>
          <button type="button" onClick={onDeleteHero} disabled={editing || loading}>주인공 삭제</button>
        </div>
        <div className="settings-bottom-link"><Link className="book-text-link" to="/heroes"><span aria-hidden="true">←</span> 나의 주인공으로 돌아가기</Link></div>
      </footer>
    </main>
  </MobilePage>
}

const SettingSectionTitle = ({ id, number, title, description }) => <div className="settings-section-title">
  <span className="settings-section-number" aria-hidden="true">{number}</span>
  <div><h2 id={id}>{title}</h2><p>{description}</p></div>
</div>

export default SettingV2
